import {ToMatchOptions} from '../../Shared/utilities/MapDiscriminatedUnion';

export class InvalidEmail {
  public static create(email: string) {
    return new InvalidEmail(email);
  }
  public readonly key = 'InvalidEmail';
  public readonly validationError = 'The e-mail is invalid.';

  private constructor(public readonly address: string) {}
}

export const emailValidationRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export class ValidEmail {
  public static create(email: string) {
    const emailRegularExpression = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return emailRegularExpression.test(email) || email === '' ? new ValidEmail(email) : InvalidEmail.create(email);
  }

  public readonly key = 'ValidEmail';
  constructor(public readonly address: string) {}
}

export const isValidEmail = (email: Email): email is ValidEmail => email.key === 'ValidEmail';

export type Email = ValidEmail | InvalidEmail;

export type EmailOptions<TReturn> = ToMatchOptions<Email, 'key', TReturn>;

export const matchEmail = <TReturn>(email: Email, options: EmailOptions<TReturn>): TReturn => {
  switch (email.key) {
    case 'InvalidEmail':
      return options.InvalidEmail(email);

    case 'ValidEmail':
      return options.ValidEmail(email);
  }
};

export const EmptyEmail = new ValidEmail('');
